import cart_page from "@/graphql/pages/CartPage.graphql";
import cart_page_no_auth from "@/graphql/pages/CartPageNoAuth.graphql";
import CartAddItems from "@/graphql/mutations/CartAddItems.graphql";
import CartDeleteItem from "@/graphql/mutations/CartDeleteItem.graphql";
import FavoriteCreateOrDelete from "@/graphql/mutations/FavoriteCreateOrDelete.graphql";
import favorites from "@/graphql/queries/favorites.graphql";
import all_favorites from "@/graphql/queries/all_favorites.graphql";
import addresses from "@/graphql/queries/addresses.graphql";
import baby_shops from "@/graphql/queries/baby_shops.graphql";
import user from "@/graphql/auth/me.graphql";

async function ME({ state }, { apollo }) {
  let token = state.apollo_token;
  return await apollo
    .query({
      query: user,
      context: {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    })
    .then(({ data }) => {
      state.auth.user = data.me;
      if (data.carts) state.auth.cart = data.carts;
      state.auth.favorites = data.favorites;
    });
}

async function GET_CART_ITEMS({ state }, { apollo }) {
  let token = state.apollo_token;
  await apollo
    .query({
      query: token ? cart_page : cart_page_no_auth,
      fetchPolicy: "network-only",
      context: {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    })
    .then(({ data }) => {
      if (data.carts) state.auth.cart = data.carts;
      state.auth.deliveries = data.deliveries;
      state.all_brands = data.brands || [];
      state.popular_brands = data.brands_paginate.data || [];
      state.categories = data.header_categories.data || [];
      state.pages = data.pages;
      state.marketplace = data.marketplace;
    });
}

async function CART_ADD_ITEMS({ state }, { apollo, variables }) {
  return await apollo.mutate({
    mutation: CartAddItems,
    variables: variables,
    context: {
      headers: {
        Authorization: "Bearer " + state.apollo_token,
      },
    },
  });
}

async function CART_DELETE_ITEMS({ state }, { apollo, variables }) {
  return await apollo.mutate({
    mutation: CartDeleteItem,
    variables: variables,
    context: {
      headers: {
        Authorization: "Bearer " + state.apollo_token,
      },
    },
  });
}

async function FAVORITE_CREATE_OR_DELETE({ state }, { apollo, variables }) {
  return await apollo.mutate({
    mutation: FavoriteCreateOrDelete,
    variables: variables,
    context: {
      headers: {
        Authorization: "Bearer " + state.apollo_token,
      },
    },
  });
}

async function GET_FAVORITES({ state }, { apollo }) {
  return await apollo
    .query({
      query: favorites,
      fetchPolicy: "network-only",
      context: {
        headers: {
          Authorization: "Bearer " + state.apollo_token,
        },
      },
    })
    .then(({ data }) => {
      state.auth.favorites = data.favorites.map((item) => item.item_id);
    });
}

async function GET_ALL_FAVORITES({ state }, { apollo }) {
  return await apollo
    .query({
      query: all_favorites,
      fetchPolicy: "network-only",
      context: {
        headers: {
          Authorization: "Bearer " + state.apollo_token,
        },
      },
    })
    .then(({ data }) => {
      state.auth.favorites_objects = data.favorites.map((item) => item.item);
    });
}

async function GET_ADDRESSES({ state }, { apollo }) {
  await apollo
    .query({
      query: addresses,
      fetchPolicy: "network-only",
      context: {
        headers: {
          Authorization: "Bearer " + state.apollo_token,
        },
      },
    })
    .then(({ data }) => {
      state.auth.addresses = data.addresses;
    });
}

async function GET_SHOPS({ state }, { apollo }) {
  await apollo
    .query({
      query: baby_shops,
      fetchPolicy: "network-only",
      context: {
        headers: {
          Authorization: "Bearer " + state.apollo_token,
        },
      },
    })
    .then(({ data }) => {
      state.baby_shops = data.baby_shops;
    });
}

export default Object.assign({
  ME,
  GET_CART_ITEMS,
  CART_ADD_ITEMS,
  CART_DELETE_ITEMS,
  FAVORITE_CREATE_OR_DELETE,
  GET_FAVORITES,
  GET_ALL_FAVORITES,
  GET_ADDRESSES,
  GET_SHOPS,
});
